import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  InputAdornment,
  IconButton,
  Avatar,
} from '@mui/material';
import { Visibility, VisibilityOff, LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

// ================== بيانات تسجيل الدخول الثابتة ==================
// ✅ عدّل القيمتين دول لأي username/password تحبهم
const STATIC_USERNAME = 'lyorauraadmin';
const STATIC_PASSWORD = 'lyoraura$2$0@2&6***';

// ================== اللوجو الافتراضي ==================
// حالياً: دايرة فيها اسم مختصر "LY". لما يجهز لوجو الشركة الحقيقي:
// 1) هات صورة اللوجو وضعها في src/assets/logo.png (أو أي مسار تختاره)
// 2) استورد الصورة فوق: import logoImg from '../assets/logo.png';
// 3) بدّل الـ <Avatar> اللي تحت بـ:
//    <Avatar src={logoImg} sx={{ width: 72, height: 72, mx: 'auto' }} />
const Logo = () => (
  <Avatar
    sx={{
      width: 72,
      height: 72,
      mx: 'auto',
      bgcolor: 'primary.main',
      fontWeight: 800,
      fontSize: 24,
      letterSpacing: 1,
    }}
  >
    LY
  </Avatar>
);

export const LoginPage = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  // لو المستخدم مسجل دخول بالفعل وفتح صفحة اللوجين تاني، وديه على الداشبورد على طول
  useEffect(() => {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      navigate('/lyorauradashboard', { replace: true });
    }
  }, [navigate]);

  const inputStyles = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('من فضلك دخل اسم المستخدم و كلمة المرور');
      return;
    }

    if (username === STATIC_USERNAME && password === STATIC_PASSWORD) {
      // نحفظ إشارة إن المستخدم داخل، عشان نستخدمها في حماية الراوت
      localStorage.setItem('isLoggedIn', 'true');
      navigate('/lyorauradashboard');
    } else {
      setError('اسم المستخدم أو كلمة المرور غير صحيحة');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 2,
      }}
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 420,
          p: 4,
          borderRadius: '16px',
          bgcolor: 'background.paper',
          border: '1px solid rgba(217,214,207,0.12)',
        }}
      >
        {/* ================== Logo & Header ================== */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Logo />
          <Typography
            variant="h5"
            sx={{ mt: 2, fontWeight: 800, color: 'text.primary', letterSpacing: 0.5 }}
          >
            lyoraura
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
            Login To Reach To dashboard
          </Typography>
        </Box>

        {error && (
          <Alert severity="warning" sx={{ mb: 2, borderRadius: '10px' }}>
            {error}
          </Alert>
        )}

        {/* ================== Username ================== */}
        <TextField
          fullWidth
          size="small"
          label="User Name"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{ mb: 2, ...inputStyles }}
          autoComplete="username"
        />

        {/* ================== Password ================== */}
        <TextField
          fullWidth
          size="small"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 3, ...inputStyles }}
          autoComplete="current-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                  size="small"
                >
                  {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* ================== Submit ================== */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<LockOutlined />}
          sx={{
            py: 1.2,
            borderRadius: '10px',
            fontWeight: 700,
            fontSize: '15px',
          }}
        >
            Login
        </Button>
      </Paper>
    </Box>
  );
};